export default "./73e6b6948f8f5103d2f25384f0b8476f.png";